function count(self, substr) {
  var count = 0
  var pos = self.indexOf(substr)

  while (pos >= 0) {
    count += 1
    pos = self.indexOf(substr, pos + 1)
  }

  return count
}

module.exports = count


//////////////////
// WEBPACK FOOTER
// /var/lib/jenkins/jobs/graylog-project-cli-release/workspace/.repos/graylog2-server/graylog2-web-interface/~/string/lib/_count.js
// module id = 669
// module chunks = 0